import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { googleSession } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { logError } from "@/lib/log";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const match = window.location.hash.match(/session_id=([^&]+)/);
        if (!match) {
            navigate("/login", { replace: true });
            return;
        }
        const run = async () => {
            try {
                const user = await googleSession(match[1]);
                setUser(user);
                window.history.replaceState(null, "", window.location.pathname);
                navigate("/console", { replace: true, state: { user } });
            } catch (e) {
                logError("[SPCLIVE] google session exchange failed", e);
                navigate("/login", { replace: true });
            }
        };
        run();
    }, [navigate, setUser]);

    return (
        <div
            className="min-h-screen bg-obsidian flex flex-col items-center justify-center gap-4"
            data-testid="auth-callback-loading"
        >
            <div className="font-display font-bold uppercase text-2xl text-white/20">SPCLIVE</div>
            <Loader2 className="w-6 h-6 text-blaze animate-spin" />
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40">
                Signing you in...
            </div>
        </div>
    );
}
